import React, { useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router';
import { useAuth } from '../commons/Auth';
import useCompany from '../context/CompanyContext';
import SecondaryButtonSm from './SecondaryButtonSm';

interface Props {
  showBanner: boolean;
  isWizardOpen: boolean;
  isHome?: boolean;
  setIsWizardOpen: Function;
}

const InputSchema = yup.object().shape({ posizione: yup.string().required('Campo obbligatorio') });

const BannerBrandPromote: React.FC<Props> = function BannerBrandPromote({ showBanner, isWizardOpen, setIsWizardOpen, isHome }) {
  const { token }: any = useAuth();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const {
    formState: { errors, isValid },
  } = useForm({ resolver: yupResolver(InputSchema), mode: 'all' });
  const {
    data: { hr_id },
  } = useCompany();
  const navigate = useNavigate();

 if (!showBanner) return null;

  return (
    
     showBanner && (
        <div className="flex flex-row items-center gap-20 bg-yellow rounded-[5px] shadow-lg m-6 px-4">
          <div className="justify-self-start py-3">
            <p className="text-white text-base font-primarybold">Promuovi il brand aziendale</p>
            <p className="text-white text-xs font-normal">
             Crea la tua vetrina aziendale in piattaforma e promuovi il tuo brand ai
            candidati industriali disponibili
            </p>
          </div>
          <div className="flex-auto self-end">
            <img className="float-right" src="./banner-img.svg" alt="" />
          </div>
          <div className="justify-self-end py-3">
            <SecondaryButtonSm text="Promuovi il tuo brand" onClick={() => isHome ? navigate('/company-promote-brand') : navigate('/company-upgrade?brandCard=true')} />
          </div>
        </div>
      )
  );
};

export default BannerBrandPromote;
